export var PortalType;
(function (PortalType) {
    PortalType["TECH"] = "tech";
    PortalType["ADMIN"] = "admin";
    PortalType["CUSTOMER"] = "customer";
    PortalType["VENDOR"] = "vendor";
})(PortalType || (PortalType = {}));
export var TechRole;
(function (TechRole) {
    TechRole["TECH_ADMIN"] = "tech_admin";
    TechRole["TECH_MANAGER"] = "tech_manager";
    TechRole["TECH_DEVELOPER"] = "tech_developer";
    TechRole["TECH_SUPPORT"] = "tech_support";
    TechRole["TECH_LEAD"] = "tech_lead";
})(TechRole || (TechRole = {}));
export var AdminRole;
(function (AdminRole) {
    AdminRole["ADMIN_SYSTEM_ADMIN"] = "admin_system_admin";
    AdminRole["ADMIN_SUPERUSER"] = "admin_superuser";
    AdminRole["ADMIN_USER"] = "admin_user";
})(AdminRole || (AdminRole = {}));
export var VendorRole;
(function (VendorRole) {
    VendorRole["VENDOR_ADMIN"] = "vendor_admin";
    VendorRole["VENDOR_MANAGER"] = "vendor_manager";
})(VendorRole || (VendorRole = {}));
export var CustomerRole;
(function (CustomerRole) {
    CustomerRole["CUSTOMER_ADMIN"] = "customer_admin";
    CustomerRole["CUSTOMER_MANAGER"] = "customer_manager";
})(CustomerRole || (CustomerRole = {}));
export var OrganizationType;
(function (OrganizationType) {
    OrganizationType["ADMIN"] = "admin";
    OrganizationType["CUSTOMER"] = "customer";
    OrganizationType["VENDOR"] = "vendor";
})(OrganizationType || (OrganizationType = {}));
export var LicenseStatus;
(function (LicenseStatus) {
    LicenseStatus["PENDING"] = "pending";
    LicenseStatus["ACTIVE"] = "active";
    LicenseStatus["EXPIRED"] = "expired";
    LicenseStatus["SUSPENDED"] = "suspended";
    LicenseStatus["REVOKED"] = "revoked";
})(LicenseStatus || (LicenseStatus = {}));
export var LicenseType;
(function (LicenseType) {
    LicenseType["TRIAL"] = "trial";
    LicenseType["STANDARD"] = "standard";
    LicenseType["PREMIUM"] = "premium";
    LicenseType["RESTRICTED"] = "restricted";
})(LicenseType || (LicenseType = {}));
export var TicketStatus;
(function (TicketStatus) {
    TicketStatus["OPEN"] = "open";
    TicketStatus["IN_PROGRESS"] = "in_progress";
    TicketStatus["RESOLVED"] = "resolved";
    TicketStatus["CLOSED"] = "closed";
    TicketStatus["ESCALATED"] = "escalated";
})(TicketStatus || (TicketStatus = {}));
export var TicketPriority;
(function (TicketPriority) {
    TicketPriority["LOW"] = "low";
    TicketPriority["MEDIUM"] = "medium";
    TicketPriority["HIGH"] = "high";
    TicketPriority["CRITICAL"] = "critical";
})(TicketPriority || (TicketPriority = {}));
export var TicketEscalationLevel;
(function (TicketEscalationLevel) {
    TicketEscalationLevel["CUSTOMER_ORG"] = "customer_org";
    TicketEscalationLevel["CENTRAL_ADMIN"] = "central_admin";
    TicketEscalationLevel["TECH_TEAM"] = "tech_team";
})(TicketEscalationLevel || (TicketEscalationLevel = {}));
export var LicenseModule;
(function (LicenseModule) {
    LicenseModule["PROCUREMENT"] = "procurement";
    LicenseModule["INVENTORY"] = "inventory";
    LicenseModule["FINANCE"] = "finance";
    LicenseModule["HR"] = "hr";
    LicenseModule["ASSETS"] = "assets";
    LicenseModule["VESSELS"] = "vessels";
    LicenseModule["ANALYTICS"] = "analytics";
})(LicenseModule || (LicenseModule = {}));
export var LicenseBillType;
(function (LicenseBillType) {
    LicenseBillType["TRIAL"] = "TRIAL";
    LicenseBillType["PAID"] = "PAID";
})(LicenseBillType || (LicenseBillType = {}));
export var PaymentStatus;
(function (PaymentStatus) {
    PaymentStatus["PAID"] = "PAID";
    PaymentStatus["UNPAID"] = "UNPAID";
    PaymentStatus["OVERDUE"] = "OVERDUE";
})(PaymentStatus || (PaymentStatus = {}));
export var UpgradeRequestType;
(function (UpgradeRequestType) {
    UpgradeRequestType["UPGRADE"] = "UPGRADE";
    UpgradeRequestType["RENEWAL"] = "RENEWAL";
})(UpgradeRequestType || (UpgradeRequestType = {}));
export var UpgradeRequestStatus;
(function (UpgradeRequestStatus) {
    UpgradeRequestStatus["PENDING"] = "PENDING";
    UpgradeRequestStatus["APPROVED"] = "APPROVED";
    UpgradeRequestStatus["REJECTED"] = "REJECTED";
})(UpgradeRequestStatus || (UpgradeRequestStatus = {}));
//# sourceMappingURL=enums.js.map